import React from "react";

const SvgUploadImage = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.51407 14.7149C4.35771 14.7149 3.32911 13.9666 2.95561 12.8526L2.93035 12.7687C2.84226 12.4737 2.80536 12.2256 2.80536 11.9773V7L1.05303 12.9117C0.827657 13.7812 1.34123 14.6827 2.20291 14.9229L13.3722 17.946C13.5116 17.9825 13.651 18 13.7883 18C14.5077 18 15.165 17.5175 15.3493 16.8063L16 14.7149H5.51407Z"
        fill="#BEBEBE"
      />
      <path
        d="M7.50007 7C8.32735 7 9 6.32725 9 5.5C9 4.67275 8.32735 4 7.50007 4C6.67279 4 6 4.67275 6 5.5C6 6.32725 6.67279 7 7.50007 7Z"
        fill="#BEBEBE"
      />
      <path
        d="M17.1249 2H5.87495C4.84155 2 4 2.84155 4 3.87508V12.1249C4 13.1585 4.84155 14 5.87495 14H17.1249C18.1584 14 19 13.1585 19 12.1249V3.87508C19 2.84155 18.1584 2 17.1249 2ZM5.87495 3.50003H17.1249C17.332 3.50003 17.5 3.66799 17.5 3.87508V9.19929L15.1308 6.43473C14.8795 6.14003 14.5157 5.98251 14.125 5.97359C13.7365 5.97578 13.372 6.14827 13.123 6.44682L10.3374 9.79021L9.42998 8.88494C8.91705 8.37202 8.08223 8.37202 7.57 8.88494L5.50004 10.9542V3.87508C5.50004 3.66799 5.66799 3.50003 5.87495 3.50003Z"
        fill="#BEBEBE"
      />
    </svg>
  );
};

export default SvgUploadImage;
